import * as tslib_1 from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
import { Address } from "./Address";
let Profile = class Profile {
    constructor() {
        this.firstName = '';
        this.lastName = '';
        this.jobTitle = '';
        this.companyName = '';
        this.emailAddress = '';
        this.officePhone = '';
        this.mobilePhone = '';
        this.username = '';
        this.createdBy = '';
        this.addresses = new Array();
        this.inactive = false;
        this.createdBy = '';
        this.accountingId = '';
        this.createDate = '';
        this.lastModifiedDate = '';
        this.title = '';
        this.accountName = '';
        this.membershipNumber = '';
        this.organization = '';
        this.birthDate = '';
        this.gender = '';
        this.description = '';
        this.externalSsoID = '';
        this.personalInformationConsent = false;
        this.externalStudentID = '';
        this.profilePhoto = '';
        this.allDocumentAccess = false;
        this.configioId = 0;
    }
};
tslib_1.__decorate([
    JsonProperty('FirstName', String, false)
], Profile.prototype, "firstName", void 0);
tslib_1.__decorate([
    JsonProperty('LastName', String, false)
], Profile.prototype, "lastName", void 0);
tslib_1.__decorate([
    JsonProperty('JobTitle', String, true)
], Profile.prototype, "jobTitle", void 0);
tslib_1.__decorate([
    JsonProperty('CompanyName', String, false)
], Profile.prototype, "companyName", void 0);
tslib_1.__decorate([
    JsonProperty('EmailAddress', String, false)
], Profile.prototype, "emailAddress", void 0);
tslib_1.__decorate([
    JsonProperty('Username', String, false)
], Profile.prototype, "username", void 0);
tslib_1.__decorate([
    JsonProperty('OfficePhone', String, true)
], Profile.prototype, "officePhone", void 0);
tslib_1.__decorate([
    JsonProperty('MobilePhone', String, true)
], Profile.prototype, "mobilePhone", void 0);
tslib_1.__decorate([
    JsonProperty('IdentityId', String, true)
], Profile.prototype, "identityId", void 0);
tslib_1.__decorate([
    JsonProperty('ConfigioId', Number, true)
], Profile.prototype, "configioId", void 0);
tslib_1.__decorate([
    JsonProperty('Addresses', [Address])
], Profile.prototype, "addresses", void 0);
tslib_1.__decorate([
    JsonProperty('Inactive', Boolean, true)
], Profile.prototype, "inactive", void 0);
tslib_1.__decorate([
    JsonProperty('CreatedBy', String, false)
], Profile.prototype, "createdBy", void 0);
tslib_1.__decorate([
    JsonProperty('AccountingId', String, true)
], Profile.prototype, "accountingId", void 0);
tslib_1.__decorate([
    JsonProperty('CreateDate', String, true)
], Profile.prototype, "createDate", void 0);
tslib_1.__decorate([
    JsonProperty('LastModifiedDate', String, true)
], Profile.prototype, "lastModifiedDate", void 0);
tslib_1.__decorate([
    JsonProperty('Title', String, true)
], Profile.prototype, "title", void 0);
tslib_1.__decorate([
    JsonProperty('AccountName', String, true)
], Profile.prototype, "accountName", void 0);
tslib_1.__decorate([
    JsonProperty('MembershipNumber', String, true)
], Profile.prototype, "membershipNumber", void 0);
tslib_1.__decorate([
    JsonProperty('Organization', String, true)
], Profile.prototype, "organization", void 0);
tslib_1.__decorate([
    JsonProperty('BirthDate', String, true)
], Profile.prototype, "birthDate", void 0);
tslib_1.__decorate([
    JsonProperty('Gender', String, true)
], Profile.prototype, "gender", void 0);
tslib_1.__decorate([
    JsonProperty('Description', String, true)
], Profile.prototype, "description", void 0);
tslib_1.__decorate([
    JsonProperty('ExternalStudentID', String, true)
], Profile.prototype, "externalStudentID", void 0);
tslib_1.__decorate([
    JsonProperty('ExternalSsoID', String, true)
], Profile.prototype, "externalSsoID", void 0);
tslib_1.__decorate([
    JsonProperty('PersonalInformationConsent', Boolean, true)
], Profile.prototype, "personalInformationConsent", void 0);
tslib_1.__decorate([
    JsonProperty('ProfilePhoto', String, true)
], Profile.prototype, "profilePhoto", void 0);
tslib_1.__decorate([
    JsonProperty('Username', String, true)
], Profile.prototype, "userName", void 0);
tslib_1.__decorate([
    JsonProperty('AllDocumentAccess', Boolean, true)
], Profile.prototype, "allDocumentAccess", void 0);
Profile = tslib_1.__decorate([
    JsonObject
], Profile);
export { Profile };
